import { z } from 'zod';

export const monthlyReportSummarySchema = z.object({
  id: z.string(),
  companyId: z.string(),
  periodStart: z.string().datetime(),
  periodEnd: z.string().datetime(),
  pdfUrl: z.string().nullable(),
  csvUrl: z.string().nullable(),
  payload: z.record(z.unknown()),
  emailedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});
export type MonthlyReportSummary = z.infer<typeof monthlyReportSummarySchema>;
